import { FC, memo, PropsWithChildren } from "react";
import { DotLoader } from "@components/icons";
import "./form-loading-overlay.scss";

interface FormLoadingOverlayProps extends PropsWithChildren {
  isLoading: boolean;
  className?: string;
}

const FormLoadingOverlayComponent: FC<FormLoadingOverlayProps> = ({
  isLoading,
  className = "",
  children,
}) => {
  return (
    <div className={`form-loading-overlay ${className}`} aria-busy={isLoading}>
      {children}
      {isLoading ? (
        <div className="form-loading-overlay-backdrop" aria-hidden="true">
          <DotLoader color="#333333" size="56" />
        </div>
      ) : null}
    </div>
  );
};

export const FormLoadingOverlay = memo(FormLoadingOverlayComponent);
